import React from "react";

const Preloader = () => {
  return (
    <>
      {/* Preloader Start*/}
      <div className="preloader bg-white">
        <div className="preloader-inner">
          <span className="loader text-theme" />
        </div>
      </div>
    </>
  );
};

export default Preloader;
